// extracted by mini-css-extract-plugin
export default {"outer":"TourFocus_outer__wUZRc","isActive":"TourFocus_isActive__jWCNT","message":"TourFocus_message__L7C99"};